module.exports = __webpack_public_path__ + "img/ch08_01_橱窗看蛋糕.6fcdbca1.jpg";